import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoiThuNgoaiLe } from "./ModalThemMoiThuNgoaiLe";

export const BtnThemMoiThuNgoaiLe = ({}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <button
        type="button"
        className="btn btn btn-border-new"
        onClick={handleShow}
      >
        <i className="mdi mdi-plus"></i> Tạo phiếu thu
      </button>
      {show && <ModalThemMoiThuNgoaiLe show={show} onHide={handleClose} />}
    </>
  );
};
